import { NextPage } from 'next'
import { Container } from '@ucheba/ui/components/Container/desktop'
import React, { memo, useMemo } from 'react'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import Image from 'next/image'
import { EProgramTypes } from '@ucheba/utils/types/program'
import { Banner } from '../../../../../components/Banner/desktop'
import { IEventsPageProps } from '../types'
import EventsPageHeader from './EventsPageHeader'
import EventsPageSelectedFacets from './EventsPageSelectedFacets'
import EventsPageFacets from './EventsPageFacets'
import data from '../../../speciality/search/data.json'
import emptySearchImage from '../assets/img__empty-search.png'
import EventsPagePagination from './EventsPagePagination'
import { EventsList } from '../../../../../components/EventsList/desktop'
import { pathname } from '../constants'

/** Страница с поиском событий */
const EventsPage: NextPage<IEventsPageProps> = (props) => {
  const { searchResults, query } = props
  const { emptySearch } = data

  const params = useMemo(() => {
    return {
      programTypes: query.programTypes || [
        EProgramTypes.higher,
        EProgramTypes.vocational,
      ],
    }
  }, [query])

  return (
    <Container>
      <EventsPageHeader />

      <Spacing spacing='xlarge' />

      <Grid>
        <GridCol uxs={16} lg={18} as='article'>
          {searchResults && <EventsPageSelectedFacets />}

          {searchResults?.items.length ? (
            <>
              <EventsList
                isBanner
                items={searchResults.items}
                href={pathname}
                params={params}
              />

              <EventsPagePagination />
            </>
          ) : (
            <>
              <Spacing spacing='uxlarge' />

              <Heading h3={emptySearch.title} textAlign='center' />

              <Spacing spacing='large' />

              <Grid justifyContent='center'>
                <GridCol width='auto'>
                  <Image src={emptySearchImage} width={200} height={168} />
                </GridCol>
              </Grid>

              <Spacing spacing='uxlarge' />
            </>
          )}
        </GridCol>

        <GridCol uxs={7} lg={6} as='aside'>
          <div style={{ paddingLeft: '32px', height: '100%' }}>
            <div>{searchResults && <EventsPageFacets />}</div>

            <div style={{ position: 'sticky', top: 0, paddingBottom: '30px' }}>
              <Banner id={3} extraParams={params} />
            </div>
          </div>
        </GridCol>
      </Grid>

      <Banner id={6} extraParams={params} />
      <Banner id={14} extraParams={params} />
      <Spacing spacing='xlarge' />
    </Container>
  )
}

export default memo(EventsPage)
